import { render, staticRenderFns } from "./AbsenceList.vue?vue&type=template&id=56855b33"
import script from "./AbsenceList.vue?vue&type=script&lang=js"
export * from "./AbsenceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports